import { Checkbox, FormControlLabel, Grid, InputAdornment, MenuItem, Switch, TextField } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { Procedure } from 'types/procedure';
import { ProcedureValidation } from '../validation/useProcedureValidation';
import PercentInput from 'components/masked-input/PercentInput';
import MoneyInput from 'components/masked-input/MoneyInput';
import { asInputComponent } from 'components/masked-input/asInputComponent';

interface ProcedureFormProps {
  procedure: Procedure;
  handleChange: <K extends keyof Procedure>(index: K, value: Procedure[K]) => void;
  validation: ProcedureValidation;
  type?: 'edit' | 'new';
}

const ProcedureForm: React.FC<ProcedureFormProps> = ({ procedure, handleChange, validation, type }) => {
  const inputs = {
    name: useRef<HTMLInputElement>(null),
    sale_price: useRef<HTMLInputElement>(null),
  };

  useEffect(() => {
    const [key] = Object.keys(validation) as [keyof typeof inputs];

    if (!key) return;

    inputs[key].current?.focus();
  }, [validation]);

  return (
    <Grid container size={12} spacing={2} maxWidth={1200}>
      <Grid size={12}>
        <TextField
          fullWidth
          autoFocus
          inputRef={inputs.name}
          label="Nome da consulta"
          placeholder="Digite o nome da consulta"
          value={procedure.name}
          onChange={e => handleChange('name', e.target.value)}
          error={!!validation.name}
          helperText={validation.name}
        />
      </Grid>

      <Grid size={12} />

      <Grid size={{ xs: 12, md: 2 }}>
        <TextField
          fullWidth
          inputRef={inputs.sale_price}
          label="Preço de Venda"
          placeholder="Digite o preço de venda"
          value={procedure.sale_price}
          onChange={e => handleChange('sale_price', Number(e.target.value))}
          error={!!validation.sale_price}
          helperText={validation.sale_price}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              inputComponent: asInputComponent(MoneyInput),
            },
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Comissão"
          placeholder="Digite a comissão"
          value={procedure.commission}
          onChange={e => handleChange('commission', Number(e.target.value))}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              inputComponent: asInputComponent(MoneyInput),
            },
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Custo"
          placeholder="Digite o custo"
          value={procedure.cost}
          onChange={e => handleChange('cost', Number(e.target.value))}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              inputComponent: asInputComponent(MoneyInput),
            },
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <FormControlLabel
          label="Somar comissão ao preço de venda"
          control={
            <Checkbox
              size="small"
              checked={!!procedure.sum_commission_to_total}
              onChange={e => handleChange('sum_commission_to_total', e.target.checked)}
            />
          }
        />
      </Grid>

      <Grid size={12}>
        <FormControlLabel
          label="Ativo"
          control={
            <Switch checked={!!procedure.active} onChange={e => handleChange('active', e.target.checked ? 1 : 0)} />
          }
        />
      </Grid>
    </Grid>
  );
};

export default ProcedureForm;
